import Swiper, { Navigation, Pagination, Autoplay, Scrollbar, Mousewheel } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Mousewheel]);

const INIT_OPTIONS = {
	init:false,
	disableMobile: false,
	disableMobileMq: ['(max-width: 767px)']
};

class SwiperCarouselCore {
	target;
	options;
	carousel;
	enabled;

	constructor(target, options) {
		 this.target = target;
		 this.options = Object.assign({}, INIT_OPTIONS, options);        
		 this.carousel = new Swiper(this.target, this.options);

		 //-resize al caricamento per assestare eventuli errori di renderizzazione
		 this.carousel.on('init', () => {
			  setTimeout(() => { 
					const event = document.createEvent('HTMLEvents');
					event.initEvent('resize', true, false);
					document.dispatchEvent(event);
			  }, 1500);
		 });   
	}

	init() {
		 this.carousel.init();
		 
		 this.bindEvents();

		 this.enabled = true;

		 this.onResize();
	}

	destroy() {
		 this.carousel.destroy();

		 this.unbindEvents();

		 this.enabled = false;
	}

	enable() {
		 this.carousel.init();
		 this.enabled = true;        
	}
	disable() {
		 this.carousel.destroy(false, false);
		 this.enabled = false;
	}

	bindEvents() {
		 if (this.options.disableMobile) {
			  window.addEventListener("resize", this.onResize);
		 }

		 if (this.target.getAttribute('id')) {
			  const links = document.querySelectorAll('.index-wrapper[data-target-slider=' + this.target.getAttribute('id') + '] a[data-slide]');
			  links.forEach((link) => link.addEventListener("click", this.onLinkToSlide));
		 }
	}
	unbindEvents() {
		 window.removeEventListener("resize", this.onResize);

		 if (this.target.getAttribute('id')) {
			  const links = document.querySelectorAll('.index-wrappe[data-target-slider=' + this.target.getAttribute('id') + '] a[data-slide]');
			  links.forEach((link) => link.removeEventListener("click", this.onLinkToSlide));
		 }
	}

	onResize = () => {
		 if (this.options.disableMobile) {
			  if (this.enabled && this.isMediaQueryMobile()) {
					this.disable();
			  } else if (!this.enabled && !this.isMediaQueryMobile()) {
					this.enable();
			  }
		 }
	}

	isMediaQueryMobile() {
		 if (!Array.isArray(this.options.disableMobileMq) || this.options.disableMobileMq.length === 0) {
			  return true;
		 }

		 const found = this.options.disableMobileMq.find(mq => window.matchMedia(mq).matches);
		 return !!found;
	}    

	nextSlide() {
		 this.carousel.slideNext();
	}
	prevSlide() {
		 this.carousel.slidePrev();
	}    

	onLinkToSlide = (evt) => {
		 evt.preventDefault();
		 const targetSlide = evt.currentTarget.getAttribute('data-slide');
		 let foundIdx = -1;
		 const slides = this.target.querySelectorAll('.swiper-slide');
		 slides.forEach((slide, idx) => {
			  if (slide.getAttribute('data-slide') === targetSlide) {
					foundIdx = idx;
			  }
		 });
		 if (foundIdx > -1) {
			  this.carousel.slideTo(foundIdx);
		 }
	}
}

class SwiperCarousel {
	core;
	
	constructor(target, options) {
		 this.core = new SwiperCarouselCore(target, options);
	}

	init() {
	  this.core.init();
	}
	destroy() {
		 this.core.destroy();
	}

	nextSlide() {
		 this.core.nextSlide();
	}
	prevSlide() {
		 this.core.prevSlide();
	}
}

export default SwiperCarousel;